<template>
  <v-dialog v-if="archive!={}"  width="800" v-model="dialog">
    <template v-slot:activator="{ on }">

      <slot name="activator" v-bind:data="{on: on, load : load}">
        <v-btn @click="load()" v-on="on" color="teal darken-4" fab small dark>
          <v-icon class="schema-edit-icon" dark>pageview</v-icon>
        </v-btn>
      </slot>
    </template>

    <v-sheet>
      <div>
        <v-progress-linear indeterminate color="primary" v-if="loading" spacing="pr-4"></v-progress-linear>
        <PdfViewer v-else :base64="`data:${documentFile.type};base64,${documentFile.data}`"></PdfViewer>
      </div>
      <v-btn style="z-index: 99999999" color="blue darken-1" flat @click="dialog=false">{{ $t('cyclic.abort') }}</v-btn>
      <v-btn v-if="documentFile.data" style="z-index: 99999999" color="green darken-1" flat @click="download()">Pobierz</v-btn>
    </v-sheet>

  </v-dialog>
</template>

<script>
import PdfViewer from "@/components/pdf/Viewer"
import Messenger from "../../plugins/Messenger"

export default {
  name: "ViewDocuemnts",
  components: {
    PdfViewer
  },
  props: ['schemaId', 'formId'],
  data() {
    return {
      documentFile: {},
      loadedDocumentsFile: [],
      dialog: false,
      loading:false
    }
  },
  computed: {
    fields() {
      return this.schema.fields
    }
  },
  methods: {
    download(){
      if(!this.documentFile){
        return;
      }

      let url = `data:${this.documentFile.type};base64,` + this.documentFile.data
      fetch(url)
        .then(res => res.blob())
        .then(binary => {
          const url = window.URL.createObjectURL(binary)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = this.documentFile.name
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
    load() {
      this.dialog = true;
      this.loading = true
      this.documentFile = {}
      let fileForm = this.loadedDocumentsFile.find(af => af.idForm == this.formId)
      if (this.loadedDocumentsFile && fileForm) {
        this.documentFile = fileForm.file
        this.loading = false
        return
      }

      this.$http.get(`document/schema/${this.schemaId}/form/${this.formId}/file`)
        .then(data => {
          this.documentFile = data.data
          this.loadedDocumentsFile.push({'idForm': this.formId, "file": data.data})
          this.loading = false
        })
        .catch(() => {
          this.dialog = false
          Messenger.emitError("Bład przy pobieraniu archiwum")
        })
    }
  }
}
</script>

<style scoped>
#btn_container {
  margin-bottom: -2rem;
}
</style>